import { get } from 'lodash';

// NOSONAR
const localeRegex = new RegExp(`^/([a-z]{2})(/|$)`, 'i');

export const getParameterValue = (paramName: string): string | null => {
  const urlParams = window.location.search;
  const regex = new RegExp(`[?&]${paramName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(urlParams);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const lastChar = (str: string | null | undefined): string =>
  (str && str.slice(-1)) || '';
const firstChar = (str: string | null | undefined): string =>
  (str && str.charAt(0)) || '';

export const join = (base: string, ...paths: string[]): string => {
  const baseWithoutEndingSlash =
    lastChar(base) === '/' ? base.slice(0, -1) : base || '';

  const pathWithoutStartingSlash =
    firstChar(paths[0]) === '/' ? paths[0].substr(1) : paths[0] || '';

  const result = `${baseWithoutEndingSlash}/${pathWithoutStartingSlash}`;
  if (paths.length <= 1) {
    return result;
  }
  return join(result, ...paths.slice(1));
};

export const replaceParams = (
  str: string,
  args: Record<string, string>
): string => {
  const paramsToReplace = Object.keys(args || {});

  const result = paramsToReplace.reduce(
    (prev, value) =>
      prev.replace(
        new RegExp(`(/)(:${value}\\??)($|/)`, 'i'),
        `$1${args[value]}$3`
      ),
    str
  );
  // NOSONAR
  return result.replace(new RegExp(`(/)(:\\w+\\??)`, 'gi'), '');
};

export const joinLocale = (locale: string, path: string): string =>
  firstChar(path) === '/' ? join('/', locale, path) : path;

export const removeLocale = (url: string): string =>
  url.replace(localeRegex, '/');

export const getLocale = (url: string): string | undefined =>
  get(url.match(localeRegex), '[1]');

export const addLocale = (locale: string, url: string): string =>
  joinLocale(locale !== 'fi' ? locale : '', removeLocale(url));

export const IsExternalUrl = (url: string): boolean => {
  const external = new RegExp(`^((f|ht)tps?:)?//(?!${window.location.host})`);
  return external.test(url);
};

export const changeUrlWithoutReloadPage = (url: string, page: string): void => {
  return window.history.pushState(page, '', url + page);
};
